"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_PROTECTED_COUNTRIES = exports.GDPR_COUNTRIES = void 0;
const country_1 = require("../enums/country");
exports.GDPR_COUNTRIES = [country_1.OrganizationCountry.Ireland, country_1.OrganizationCountry.Germany];
exports.DATA_PROTECTED_COUNTRIES = [country_1.OrganizationCountry.GreatBritain, ...exports.GDPR_COUNTRIES];
